const DIRECT_CHAT_API = {
  GET_RECENT_USERS: {
    path: '/direct-chat/recent-users',
    method: 'GET',
  },
  GET_TENANT_USERS: {
    path: '/direct-chat/tenant-users',
    method: 'GET',
  },
  POST_OPEN_CONVERSATION: {
    path: '/direct-chat/conversations/open',
    method: 'POST',
  },
  POST_CREATE_CONVERSATION: {
    path: '/direct-chat/conversations',
    method: 'POST',
  },
  GET_CONVERSATIONS: {
    path: '/direct-chat/conversations',
    method: 'GET',
  },
  GET_SINGLE_CONVERSATION: {
    path: '/direct-chat/conversations',
    method: 'GET',
  },
  PUT_SEND_MESSAGE: {
    path: '/direct-chat/conversations',
    method: 'PUT',
  },
  POST_READ_ALL: {
    path: '/direct-chat/conversations',
    method: 'POST',
  },
  POST_UPLOAD: {
    path: '/direct-chat/upload',
    method: 'POST',
  },
};

export default DIRECT_CHAT_API;
